import React, { useEffect, useState } from 'react';

import Modal from 'common/Modal';
import { Events, eventsService, ShowInfoModalEvent } from 'services/EventsService';

type ModalData = {
  title: string;
  body: string;
  position: 'center' | 'bottom';
} | null;

export const InfoModal: React.FC = React.memo(() => {
  const [modalData, setModalData] = useState<ModalData>(null);

  useEffect(() => {
    const handleShowInfoModal = (event: ShowInfoModalEvent) => {
      const { title, body, position } = event.detail;

      setModalData({
        title,
        body,
        position,
      });
    };

    eventsService.on(Events.ShowInfoModal, handleShowInfoModal);

    return () => {
      eventsService.off(Events.ShowInfoModal, handleShowInfoModal);
    };
  }, []);

  const handleClose = () => setModalData(null);

  if (!modalData) {
    return null;
  }

  return (
    <Modal
      title={modalData.title}
      showCancel={false}
      position={modalData.position}
      onClose={handleClose}
    >
      <div dangerouslySetInnerHTML={{ __html: modalData.body }} />
    </Modal>
  );
});
